import { InflatingAppLoader } from '~/components/common/InflatingAppLoader'
import { LayoutWithNothing } from '~/components/LayoutWithNothing'
import Router from 'next/router'
import React, { useEffect, useState } from 'react'
import { AdvAccount } from '~/lib/types/AdvAccount'
import { UserAdv } from '~/lib/types/UserAdv'
import { FirebaseUser } from '~/lib/firebase/auth'
import { usePartialAuth } from '../contexts/AuthContext'

export const authenticate = (
  Page: React.ComponentType & { authenticate?: unknown; Layout?: unknown },
  config: (state: {
    currentUser: FirebaseUser | null
    currentAdv: AdvAccount | null
    currentUserAdv: UserAdv | null
  }) => {
    loading?: boolean
    redirects?: [string, boolean][]
  },
) => {
  const PageWrapper = () => {
    const { currentUser, currentAdv, currentUserAdv } = usePartialAuth()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
      const { loading, redirects } = config({
        currentUser,
        currentAdv,
        currentUserAdv,
      })

      let willRedirect = false
      for (const [redirect, isRedirect] of redirects || []) {
        if (isRedirect) {
          Router.push(redirect)
          willRedirect = true
          break
        }
      }

      if (!willRedirect && !loading) setLoading(false)
    }, [currentUser, currentAdv, currentUserAdv])

    if (loading) return <InflatingAppLoader />

    return <Page />
  }

  PageWrapper.Layout = Page.Layout ?? LayoutWithNothing

  return PageWrapper
}
